// 眼别下拉选项
export const eyeSelectOptions = [
  {
    label: '左眼',
    value: 'OS',
  },
  {
    label: '右眼',
    value: 'OD',
  },
  {
    label: '双眼',
    value: 'OU',
  }
]

// 眼别下拉选项
export const eye2SelectOptions = [
  {
    label: '左眼',
    value: 'OS',
  },
  {
    label: '右眼',
    value: 'OD',
  },
  {
    label: '双眼',
    value: 'OU',
  }
]

// 眼镜直径下拉选项
export const diameterSelectOptions = [
  {
    label: '50',
    value: 50,
  },
  {
    label: '55',
    value: 55,
  },
  {
    label: '60',
    value: 60,
  },
  {
    label: '65',
    value: 65,
  },
  {
    label: '70',
    value: 70,
  },
  {
    label: '75',
    value: 75,
  },
  {
    label: '80',
    value: 80,
  },
  {
    label: '85',
    value: 85,
  },
  {
    label: '90',
    value: 90,
  },
  {
    label: '95',
    value: 95,
  },
]

// 镜片通道下拉选项
export const channelSelectOptions = [
  {
    label: '5',
    value: 5,
  },
  {
    label: '6',
    value: 6,
  },
  {
    label: '7',
    value: 7,
  },
  {
    label: '8',
    value: 8,
  },
  {
    label: '9',
    value: 9,
  },
  {
    label: '10',
    value: 10,
  },
  {
    label: '11',
    value: 11,
  },
  {
    label: '12',
    value: 12,
  },
  {
    label: '13',
    value: 13,
  },
  {
    label: '14',
    value: 14,
  },
  {
    label: '15',
    value: 15,
  },
  {
    label: '16',
    value: 16,
  },
]

export const drugDaysOptions = [
  {
    label: '1天',
    value: '1天',
  },
  {
    label: '2天',
    value: '2天',
  },
  {
    label: '3天',
    value: '3天',
  },
  {
    label: '4天',
    value: '4天',
  },
  {
    label: '5天',
    value: '5天',
  },
  {
    label: '6天',
    value: '6天',
  },
  {
    label: '7天',
    value: '7天',
  },
  {
    label: '8天',
    value: '8天',
  },
  {
    label: '9天',
    value: '9天',
  },
  {
    label: '10天',
    value: '10天',
  },
  {
    label: '2周',
    value: '2周 ',
  },
  {
    label: '3周',
    value: '3周',
  },
  {
    label: '1个月',
    value: '1个月'
  },
  {
    label: '3个月',
    value: '3个月'
  },
  {
    label: '半年',
    value: '半年'
  },
  {
    label: '长期',
    value: '长期'
  }
];

export const drugUseMethodOptions = [
  {
    label: '口服',
    value: '口服'
  },
  {
    label: '外用冷敷',
    value: '外用冷敷'
  },
  {
    label: '外用热敷',
    value: '外用热敷'
  },
  {
    label: ' 滴眼',
    value: '滴眼'
  },
  {
    label: ' 涂抹',
    value: '涂抹'
  },
]
export const drugCountPerDayOptions = [
  {
    label: '1次/2小时',
    value: '1次/2小时'
  },
  {
    label: '1次/天',
    value: '1次/天'
  },
  {
    label: '2次/天',
    value: '2次/天'
  },
  {
    label: '3次/天',
    value: '3次/天'
  },
  {
    label: '4次/2小时',
    value: '4次/2小时'
  }
]
export const drugTimeInDayOptions = [
  {
    label: '睡前',
    value: '睡前'
  },
  {
    label: '日间',
    value: '日间'
  }
]
export const drugCountPerTimeOptions = [
  {
    label: '一次1滴/片/粒',
    value: '一次1滴/片/粒'
  },
  {
    label: '一次2滴/片/粒',
    value: '一次2滴/片/粒'
  },
  {
    label: '一次3滴/片/粒',
    value: '一次3滴/片/粒'
  },
]